import initialStates from '../../initialStates';
import {
    FETCH_BLOCK_LIST_REQUEST,
    FETCH_BLOCK_LIST_SUCCESS,
    FETCH_BLOCK_LIST_FAILURE,
    CREATE_BLOCK_SUCCESS,
    CLEAR_BLOCK_STATE,
} from './block-actions';

const blockReducer = (state = initialStates.block, action) => {
    let newState = {};
    switch (action.type) {
    case FETCH_BLOCK_LIST_REQUEST:
        newState = Object.assign({}, state, { isLoading: true });
        break;
    case FETCH_BLOCK_LIST_SUCCESS:
        newState = Object.assign({}, state, {
            isLoading: false,
            list: action.data.content,
            page: action.data.number,
            size: action.data.size,
            totalElements: action.data.totalElements,
        });
        break;
    case FETCH_BLOCK_LIST_FAILURE:
        newState = Object.assign({}, state, { isLoading: false });
        break;

    case CLEAR_BLOCK_STATE:
        newState = initialStates.block;
        break;
    case CREATE_BLOCK_SUCCESS:
        newState = {
            ...state,
            selectedBlock: action.data,
        };
        break;
    default:
        newState = state;
    }
    return newState;
};

export default blockReducer;
